import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {useRef} from "react";
import {StereotypeApiClient} from "../../../../../common/apis/stereotype/StereotypeApiClient";
import {AttributeDefinitionDto} from "../../../../../common/apis/stereotype/AttributeDefinitionDto";

export function useAttributeDefinitionQuery(stereotypeId: string | undefined): UseQueryResult<AttributeDefinitionDto[], any> {
    const stereotypeApiClient = useRef(new StereotypeApiClient());

    return useQuery({
        queryKey: ["stereotypes.stereotype", stereotypeId, "attributes"],
        queryFn: () => stereotypeApiClient.current.findAllAttributes(stereotypeId!),
        enabled: !!stereotypeId,
    });
}